'use strict';

var Hoek = require('@hapi/hoek');

var Symbols = require('../symbols');

var internals = {};

exports.concat = function (target, source) {
  if (!source) {
    return target;
  }

  var obj = Object.assign({}, target);
  var language = source.language;
  Object.assign(obj, source);

  if (language && target && target.language) {
    obj.language = Hoek.applyToDefaults(target.language, language);
  }

  if (obj[Symbols.settingsCache]) {
    delete obj[Symbols.settingsCache];
  }

  return obj;
};